import { render, staticRenderFns } from "./IntegrationLogo.vue?vue&type=template&id=277a5bb5&functional=true"
import script from "./IntegrationLogo.vue?vue&type=script&lang=js"
export * from "./IntegrationLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports